import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-combo_icon_bef",
  "use": "icon-combo_icon_bef-usage",
  "viewBox": "0 0 8 5",
  "content": "<symbol viewBox=\"0 0 8 5\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-combo_icon_bef\">\n    <!-- Generator: Sketch 57.1 (83088) - https://sketch.com -->\n    <title>icon_arrow</title>\n    <desc>Created with Sketch.</desc>\n    <g id=\"icon-combo_icon_bef_蓝智后台-菜单+分析+列表+应用+弹窗\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"icon-combo_icon_bef_应用列表1模板\" transform=\"translate(-522.000000, -452.000000)\" fill=\"#909399\">\n            <g id=\"icon-combo_icon_bef_查询input\" transform=\"translate(140.000000, 374.000000)\">\n                <g id=\"icon-combo_icon_bef_input_default备份\" transform=\"translate(0.000000, 60.000000)\">\n                    <polygon id=\"icon-combo_icon_bef_icon_arrow\" points=\"382 18 386 23 390 18\" />\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/svg/combo_icon_bef.svg
// module id = JLFx
// module chunks = 1